import { render, staticRenderFns } from "./TargetBuildPlatformSummary.vue?vue&type=template&id=706d786c&scoped=true"
import script from "./TargetBuildPlatformSummary.vue?vue&type=script&lang=js"
export * from "./TargetBuildPlatformSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d786c",
  null
  
)

export default component.exports